export default {"src":"/_next/static/media/construction.88b57ecf.svg","height":160,"width":160};